import { MaxbrainImage } from 'app/library/image-library/models/maxbrain-image.model';
import { ModuleKind } from 'app/library/module/enums/module-kind.enum';
import { ModuleCategory } from 'app/library/module/enums/moduleCategory';
import { IDefaultExecutionQuery } from '../interfaces/default-execution.query.interface';

export class DefaultExecution {
    id: string;
    name: string;
    startDate: Date;
    endDate: Date;
    image: MaxbrainImage;
    type: string;
    participantCount: number;
    kind: ModuleKind;
    status: ModuleCategory;
    isDefault: boolean;

    constructor(defaultExecutionQuery: IDefaultExecutionQuery) {
        if (defaultExecutionQuery) {
            this.id = defaultExecutionQuery.id.toString();
            this.name = defaultExecutionQuery.name.toString();
            this.startDate = defaultExecutionQuery.start_date;
            this.endDate = defaultExecutionQuery.end_date;
            this.image = defaultExecutionQuery.image ? new MaxbrainImage(defaultExecutionQuery.image) : null;
            this.type = defaultExecutionQuery.type;
            this.participantCount = defaultExecutionQuery.participant_count;
            this.kind = defaultExecutionQuery.kind;
            this.status = defaultExecutionQuery.status;
            this.isDefault = true; // always true, frontend helper
        }
    }
}
